import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiServiceService } from '../services/api-service.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptorInterceptor implements HttpInterceptor {

  constructor(private service: ApiServiceService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.service.addClass();
    return next.handle(request).pipe(finalize(() => {
    this.service.removeClass();
  })
  );
  }
  }
